'use strict'
import animLottie from "./AnimLottie"
import AddClassIsAnimStart from "./AddClassIsAnimStart"


class PopIn{

    constructor(element){
        this.element = element;
        this.id = this.element.dataset.id;
        this.parent = document.querySelector(".portraits");
        this.popinBg = document.createElement("section");
        this.voile = document.createElement("div");
        this.closeButton = document.createElement("div");
        this.popinWindow = document.createElement("div");
        this.popinContent = document.createElement("div");
        this.url = apiConfig.ajaxUrlGetMembre + this.id;
        this.slugname = this.element.dataset.slugname;
    }
    create(){
        this.createPopinBox();
        this.openPopin();
    }
    createPopinBox(){
       //add ELements
        this.parent.appendChild(this.popinBg);
        this.popinBg.appendChild(this.popinWindow);
        this.popinBg.appendChild(this.voile);
        this.popinWindow.appendChild(this.closeButton);
        this.popinWindow.appendChild(this.popinContent);

        //Add Class
        this.closeButton.classList.add("popin--close");
        this.popinContent.classList.add("popin--content");
        this.popinBg.classList.add("page-cv"); 
        this.voile.classList.add("page-cv--voile");
        this.popinWindow.classList.add("popin");
        //
    }
    openPopin(){
        setTimeout(()=>{
            this.popinBg.classList.add("isVisible")
            this.popinWindow.classList.add("isVisible")
            this.loadContent(this.url)     
            window.document.body.style.overflow = "hidden"   
        },100)   
    }
    closePopin(){
        window.document.body.style.overflow = "auto" ;
        this.popinWindow.classList.remove("isVisible");
        this.popinBg.classList.remove("isVisible");

        //wait before remove Elements 
        setTimeout(()=>{
            this.popinBg.remove(0);
        }, 500)   
        
        // reset url
        window.history.pushState("home", null, "/");
    }
    loadContent(url){
        let _this = this;
        let content = {};
        let xmlhttp = new XMLHttpRequest();
        let box = document.querySelector(".popin--content");
        //
        xmlhttp.open("GET", url, true);

        xmlhttp.onreadystatechange = function() {
            if (xmlhttp.readyState == 4 && xmlhttp.status == 200){
                content = JSON.parse(xmlhttp.responseText)
               
                box.innerHTML = content.data.html;
                box.classList.add("isVisible");

                // Create intersectionObserver and animate elements with add class "isAnimStart" and after "isAnimEnd"
                let elementsPopIn = document.querySelectorAll(".cv--name, .cv--poste, .cv--chapo, .cv--body, .resume, .cv--email");
                let animElementsPopIn = new AddClassIsAnimStart(elementsPopIn);
                animElementsPopIn.anime();

                //afficher l'animation Lottie
                animLottie('.cv--picture .cv--shape','popin/circles.json');
                
                //constrols URL
                history.pushState(_this.slugname, null, "/#"+ _this.slugname + "-" + _this.id);

                //chargement du script twitter ? 
                // <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
                if (typeof tarteaucitron !== 'undefined') {
                    if( tarteaucitron.state.twittertimeline === true) {
                        let script = document.createElement("script");
                        script.src = "https://platform.twitter.com/widgets.js";
                        script.charset = "utf-8";
                        box.appendChild(script);
                    }
                }

                //close Popin
                _this.closeButton.addEventListener("click", ()=>{
                     _this.closePopin(); 
                })
                _this.voile.addEventListener("click", ()=>{ 
                    _this.closePopin();
                })

                //close popin au back
                //https://gist.github.com/w33tmaricich/7009931     
                if (typeof history.pushState === "function") {
                    window.onpopstate = function () {
                        _this.closePopin();
                    };
                }   
            }
        };
        xmlhttp.send(null);
    }
}

export default PopIn


// WEBPACK FOOTER //
// ./src/scripts/components/Popin.js